import { Box, makeStyles, Button, ButtonGroup, Card, TextField, Grid, Fab, Input, Checkbox, Typography } from '@material-ui/core'
import React, { useEffect, useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { HeaderBlock } from '../../components/header-block/HeaderBlock'
import { Loading } from '../../components/loading/Loading'
import PageContainer from '../../components/page-container/PageContainer'
import { DeleteModal } from '../../containers/delete-modal/DeleteModal'
import { getProducts } from '../../state/actions/ProductActions'
import { getPriceList, savePriceList, deletePriceList, updatePriceList } from '../../state/actions/PriceListsActions'
import styles from "./ViewPriceListPage.module.scss";
import AddIcon from '@material-ui/icons/Add';
import GenericPickerModal from '../../containers/generic-picker-modal/GenericPickerModal'
import { PriceListItemModel, PriceListItemModelDefaultPartitionKey } from './models/PriceListItemModel';
import { UUID } from "../../helpers/uuid";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import { PriceListModel, PriceListModelDefaultPartitionKey } from './models/PriceListModel'
import DeleteIcon from '@material-ui/icons/Delete';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import { useTranslation } from 'react-i18next'
import CurrencySymbol from '../../containers/currency-symbol/CurrencySymbol'
import { SalesOrgIds } from 'state/constants/SalesOrgIds'
import ProductPickerModal from 'containers/generic-picker-modal/ProductPickerModal'

const useStyles = makeStyles(theme => ({
    listableCard: {
        margin: "30px"
    },
    margin: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    fab: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        zIndex: 1
    },
    fabDisabled: {
        opacity: 0,
    },
    deleteButtonRoot: {
        marginRight: "8px"
    },
    boxRoot: {
        padding: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    placeholderRoot: {
        opacity: 0.3
    }
}));

function ViewPriceListPage(props) {
    const classes = useStyles();

    const priceList = useSelector(state => state.PriceListsReducer.priceList);
    const products = useSelector(state => state.ProductReducer.products);

    const dispatch = useDispatch()
    const [t, i18n] = useTranslation()

    const [loading, setLoading] = useState(false)
    const [loadingProducts, setLoadingProducts] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [editing, setEditing] = useState(false)
    const [uneditedPriceList, setUneditedPriceList] = useState(priceList)
    const [editedPriceList, setEditedPriceList] = useState(priceList)
    const [productModalOpen, setProductModalOpen] = useState(false)
    const [selectedProducts, setSelectedProducts] = useState({})
    const [isNew, setIsNew] = useState({})
    const [deleteAlertShowing, setDeleteAlertShowing] = useState(false)
    const [duplicateAlertShowing, setDuplicateAlertShowing] = useState(false)
    const [priceListErrorShowing, setPriceListErrorShowing] = useState(false)

    useEffect(() => {
        if (props.match.params.priceListId != null) {
            setIsNew(false);

            setLoading(true);
            dispatch(getPriceList(true, props.match.params.priceListId, (priceListResponse) => {
                setLoading(false);

                if (priceListResponse != null) {
                    setEditedPriceList(priceListResponse);
                    setUneditedPriceList(priceListResponse);
                } else {
                    setEditedPriceList({});
                    setUneditedPriceList({});
                }
            }));
        } else {
            setEditing(true);
            setIsNew(true);

            // Create a new price list...
            var priceList = new PriceListModel(
                UUID(),
                PriceListModelDefaultPartitionKey,
                "PriceList",
                null,
                true,
                (new Date()).toISOString()
            )

            setEditedPriceList(priceList);
            setUneditedPriceList(priceList);
        }
    }, [])

    useEffect(() => {
        setLoadingProducts(true);

        dispatch((getProducts(() => {
            setLoadingProducts(false);
        })));
    }, []);

    function selectAllProducts() {
        if (editedPriceList.PriceListItems != null) {
            if (Object.keys(selectedProducts).length === editedPriceList.PriceListItems.length) {
                setSelectedProducts({});
                return;
            }

            // Otherwise select all...
            let selectedIds = {};
            editedPriceList.PriceListItems.forEach((product) => selectedIds[product.ProductId] = true);
            setSelectedProducts(selectedIds);
        }
    }

    function deleteSelectedProducts() {
        var selectedPriceListItems = Object.keys(selectedProducts);

        if (selectedPriceListItems.length > 0) {
            var newPriceList = Object.assign({}, editedPriceList);

            newPriceList.PriceListItems = newPriceList.PriceListItems.filter(priceListItem =>
                !selectedPriceListItems.includes(priceListItem.ProductId)
            );

            setSelectedProducts({});
            setEditedPriceList(newPriceList);
        }
    }

    function alertDialog(title, message, options, isOpen) {
        return (
            <AlertDialog
                title={title}
                description={message}
                options={options}
                isOpen={isOpen}
            />
        );
    }

    function getContent() {
        let priceListItems = editedPriceList.PriceListItems;

        if (priceListItems == null) {
            priceListItems = [];
        }

        var selectedPriceListItems = Object.keys(selectedProducts);

        return (
            <Box px={2} py={2}>
                <Grid container spacing={2}>
                    <Grid xs={12} item>
                        <Card>
                            <Box px={2} py={2}>
                                <TextField disabled={!editing} value={editedPriceList.Name == null ? "" : editedPriceList.Name} onChange={(event) => {
                                    let newPriceList = Object.assign({}, editedPriceList);
                                    newPriceList.Name = event.target.value;
                                    setEditedPriceList(newPriceList);
                                }} fullWidth label={t('common.name')} variant="outlined" />
                            </Box>
                        </Card>
                    </Grid>
                    <Grid xs={12} item>
                        <TableContainer component={Paper}>
                            {priceListItems.length == 0 &&
                                <Grid container alignContent="center" justify="center" direction="row">
                                    <Box px={6} py={6}>
                                        <Typography classes={{ root: classes.placeholderRoot }} variant="h6">
                                            {t('price-list.no-items')}
                                        </Typography>
                                    </Box>
                                </Grid>
                            }
                            {priceListItems.length > 0 &&
                                <Fragment>
                                    <Box px={2} py={2}>
                                        <Grid container spacing={2}>
                                            <Grid xs={6} item>
                                                <Typography variant="h5">
                                                    {t('price-list.price-list-items')}
                                                </Typography>
                                            </Grid>
                                            <Grid container alignItems="flex-start" justify="flex-end" direction="row" xs={6}>
                                                <Button
                                                    onClick={() => deleteSelectedProducts()}
                                                    disabled={!editing}
                                                    color="primary"
                                                    className={classes.button}
                                                    startIcon={<DeleteIcon />}
                                                >
                                                    {t('common.delete')}
                                                </Button>
                                            </Grid>
                                        </Grid>

                                    </Box>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        disabled={!editing}
                                                        checked={priceListItems.length > 0 && selectedPriceListItems.length === priceListItems.length}
                                                        onChange={() => selectAllProducts()}
                                                    />
                                                </TableCell>
                                                <TableCell>{t('product.product-name')}</TableCell>
                                                <TableCell align="right">{t('product.product-id')}</TableCell>
                                                <TableCell align="right">{t('price-list.rrp')}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {priceListItems.map((product, index) =>
                                                (
                                                    <TableRow key={product.id}>
                                                        <TableCell padding="checkbox">
                                                            <Checkbox
                                                                disabled={!editing}
                                                                onChange={(event) => {
                                                                    let newSelectedProducts = Object.assign({}, selectedProducts);

                                                                    if (newSelectedProducts.hasOwnProperty(product.ProductId)) {
                                                                        delete newSelectedProducts[product.ProductId];
                                                                    } else {
                                                                        newSelectedProducts[product.ProductId] = event.target.checked;
                                                                    }

                                                                    setSelectedProducts(newSelectedProducts);
                                                                }}
                                                                checked={selectedProducts.hasOwnProperty(product.ProductId)}
                                                            />
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {products[product.ProductId] == null ? "" : products[product.ProductId].ProductName}
                                                        </TableCell>
                                                        <TableCell align="right">{product.ProductId}</TableCell>
                                                        <TableCell align="right">
                                                            <TextField
                                                                disabled={!editing}
                                                                type="number"
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start"><CurrencySymbol /></InputAdornment>,
                                                                }}
                                                                value={product.Value} onChange={(event) => {
                                                                    let newPriceList = Object.assign({}, editedPriceList);
                                                                    newPriceList.PriceListItems[index].Value = parseFloat(event.target.value);
                                                                    setEditedPriceList(newPriceList);
                                                                }} fullWidth variant="outlined" />
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            )}
                                        </TableBody>
                                    </Table>
                                </Fragment>
                            }
                        </TableContainer>
                    </Grid>
                </Grid>
            </Box>
        )
    }

    function getTitle() {
        if (editedPriceList.Name == null) {
            return t('price-list.new-rrp-price-list')
        } else {
            return (editedPriceList.Name == null) ? "" : editedPriceList.Name;
        }
    }

    function commitDeletePriceList() {
        setEditing(false);

        dispatch(deletePriceList([editedPriceList.id], (success) => {
            // Deleted price list.
            if (success) {
                var url = props.match.path;
                url = url.replace(":priceListId", "");
                props.history.push(url);
            }
        }));
    }

    function duplicatePriceList() {
        setEditing(false);

        // Create duplicate...
        var duplicatePriceList = Object.assign({}, editedPriceList);
        duplicatePriceList.Name = t("price-list.copy", { name: duplicatePriceList.Name })
        duplicatePriceList.id = UUID();

        duplicatePriceList.PriceListItems.map((item) => {
            item.id = UUID();
            item.PriceListId = duplicatePriceList.id;
            return item;
        });

        dispatch(savePriceList(duplicatePriceList, (success) => {
            // Deleted price list.
            if (success) {
                var url = props.match.path;
                url = url.replace(":priceListId", "");
                props.history.push(url);
            }
        }));
    }

    function isInt(n) {
        return Number(n) === n && n % 1 === 0;
    }

    function isFloat(n) {
        return Number(n) === n && n % 1 !== 0;
    }

    function commitPriceList() {
        if (Array.isArray(editedPriceList.PriceListItems)) {
            var validPricing = true;

            editedPriceList.PriceListItems.forEach((item) => {
                if (!isFloat(item.Value) && !isInt(item.Value)) {
                    validPricing = false;
                }
            });

            if (!validPricing) {
                setPriceListErrorShowing(true);
                return;
            }
        }

        if (isNew) {
            dispatch(savePriceList(editedPriceList, (success) => {
                // Saved price list.
                if (success && isNew) {
                    var url = props.match.path;
                    url = url.replace(":priceListId", "");
                    props.history.push(url);
                }
            }));
        } else {
            dispatch(updatePriceList(editedPriceList, (success) => {
                // Updated price list
                if (success) {
                    setEditedPriceList(editedPriceList);
                    setUneditedPriceList(editedPriceList);
                }
            }));
        }

        setEditing(false);
    }

    function handleOutOfStockSelection(selectedProducts) {
        let newPriceList = Object.assign({}, editedPriceList);

        if (!Array.isArray(newPriceList.PriceListItems)) {
            newPriceList.PriceListItems = [];
        }

        newPriceList.PriceListItems = newPriceList.PriceListItems.concat(selectedProducts.map((productId) => {
            return new PriceListItemModel(UUID(), PriceListItemModelDefaultPartitionKey, editedPriceList.id, "PriceListItem", "RRP", null, productId, null, true, (new Date()).toISOString())
        }));

        setEditedPriceList(newPriceList);
        setProductModalOpen(false);
    }

    function setupButtonGroup() {
        return (
            <Box className={styles.buttonContainer}>
                {!isNew &&
                    <Fragment>
                        <Button
                            classes={{ root: classes.deleteButtonRoot }}
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                                setDeleteAlertShowing(true);
                            }}
                        >
                            {t('common.delete')}
                        </Button>
                        <Button
                            classes={{ root: classes.deleteButtonRoot }}
                            variant="outlined"
                            color="secondary"
                            onClick={() => {
                                setDuplicateAlertShowing(true);
                            }}
                        >
                            {t('common.duplicate')}
                        </Button>
                    </Fragment>
                }
                <ButtonGroup>
                    {editing ? (
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => {
                                setEditedPriceList(uneditedPriceList);
                                setEditing(false);
                            }}
                        >
                            {t('common.cancel')}
                        </Button>
                    ) : null}
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => {
                            if (editing) {
                                commitPriceList();
                            } else {
                                setEditing(true);
                            }
                        }}
                    >
                        {editing ? t('common.save') : t('common.edit')}
                    </Button>
                </ButtonGroup>
            </Box>
        );
    }

   
    return (
        <Box>
            <HeaderBlock title={getTitle()} right={setupButtonGroup()} />

            {alertDialog(t("common.remove-question"), t("common.remove-description"), [
                {
                    label: t('common.cancel'),
                    action: () => setDeleteAlertShowing(false)
                },
                { label: t('common.delete'), action: () => commitDeletePriceList() }
            ], deleteAlertShowing)}

            {alertDialog(t('price-list.duplicate-question'), t('price-list.duplicate-description'), [
                {
                    label: t('common.cancel'),
                    action: () => setDuplicateAlertShowing(false)
                },
                { label: t('common.proceed'), action: () => duplicatePriceList() }
            ], duplicateAlertShowing)}

            {alertDialog(t('price-list.no-pricing'), t('price-list.no-valid-rrp'), [
                {
                    label: t('common.cancel'),
                    action: () => setPriceListErrorShowing(false)
                },
                { label: t('common.okay'), action: () => setPriceListErrorShowing(false) }
            ], priceListErrorShowing)}

            <ProductPickerModal
                handleProductSelection={selectedProducts => handleOutOfStockSelection(selectedProducts)}
                productModalOpen={productModalOpen}
                selected={editedPriceList.PriceListItems != null ? editedPriceList.PriceListItems.map(product => product.ProductId) : []}
                setProductModalOpen={() => setProductModalOpen(false)}
            />

            <PageContainer>
                <Fab
                    disabled={!editing}
                    onClick={() => setProductModalOpen(true)}
                    variant="extended"
                    color="primary"
                    aria-label="add"
                    classes={{ root: classes.fab, disabled: classes.fabDisabled }}
                >
                    <AddIcon className={classes.extendedIcon} />
                    {t('distributor.add-product')}
                </Fab>
                {loading ? <Loading /> : getContent()}
            </PageContainer>
        </Box>
    )
}

export default ViewPriceListPage

